import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, JsonpClientBackend } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { EditFilterData, FetchedData, FetchMarginData, FilterData, GridList, GridNames, GridStatus, MarginData, MarginDataById, SaveMarginData, SaveMsg } from '../models/margin-modal';
import { DataEncryptDecryptService } from './../../shared/services/dataEncryptionDecryption.service';



@Injectable({
  providedIn: 'root'
})
export class MarginService {

  dataEmitter = new EventEmitter<MarginData>();
  fetchMarginEmitter = new EventEmitter<FilterData>();
  fetchmarginButtonEventEmitter=new EventEmitter<void>();
  editMarginEmitter = new EventEmitter<EditFilterData>();

  private apiUrl: string = environment.apiUrl + 'api/margin';

  constructor(private http: HttpClient, private dataEncryption: DataEncryptDecryptService) { }

  getMarginData(): Observable<MarginData> {
    return this.http.get<MarginData>(this.apiUrl);
  }

  getFilterEmittedData(): Observable<FilterData[]> {
    return this.http.get<FilterData[]>(this.apiUrl);
  }
  getCalculateMargin(passcode: string, fetchMarginData: FetchMarginData[]): Observable<FetchedData> {
    const passPhrase = this.dataEncryption.encryption(passcode);
    let marginType = JSON.stringify(fetchMarginData);
    const url = `${this.apiUrl}/calcdata`;
    return this.http.post<FetchedData>(url, { passPhrase, marginType });
  }

  saveMarginCalculator(gridId: number,saveMarginData :SaveMarginData[]):Observable<SaveMsg> {
    let saveMargin = JSON.stringify(saveMarginData);
    const url = `${this.apiUrl}/savemargin`;
    return this.http.post<SaveMsg>(url, { gridId, saveMargin });
  }

  getMarginCalculatorGridNames():Observable<GridList> {
    const url = `${this.apiUrl}/getgridnames`;
    return this.http.get<GridList>(url);
  }

  deleteMarginCalculatorGridName(batchId: number): Observable<SaveMsg> {
    const url = `${this.apiUrl}/deletegridname/${batchId}`;
    return this.http.get<SaveMsg>(url);
  }

  getMarginCalculatorGridById(batchId: number): Observable<MarginDataById> {
    const url =  `${this.apiUrl}/getmarginbyid/${batchId}`;
    return this.http.get<MarginDataById>(url);
  }

  getMarginGridStatus(): Observable<GridStatus> {
    const url =  `${this.apiUrl}/getmarginstatus`;
    return this.http.get<GridStatus>(url);
  }
}
